import { styled as p, Box as h } from "@mui/material";
import { CurrencyTokenType as o } from "../../currency-lib/constants/currency.js";
import "../../temp-lib/styles/theme.js";
import { jsxs as u, jsx as e } from "react/jsx-runtime";
import "../../temp-lib/legacy/header/Header.js";
import "../../temp-lib/legacy/infoAccordion/InfoAccordion.js";
import "../../temp-lib/legacy/layout/Layout.js";
import "../../temp-lib/legacy/nav/Nav.js";
import "@metamask/detect-provider";
import "../../temp-lib/legacy/util/provider/Web3Instance.js";
import "jsonwebtoken";
import * as i from "ramda";
import "web3";
import "../../temp-lib/legacy/util/provider/WalletConnect.js";
import "../../download-lib/deserializes/yup/download.js";
import "../../temp-lib/components/account/adeptus/AdeptusCodeInput.js";
import "../../temp-lib/components/account/adeptus/AdeptusSuccessPopup.js";
import "../../temp-lib/components/account/share/ConfirmButton.js";
import "../../temp-lib/components/account/share/FormControlledPassword.js";
import "i18next";
import { useState as w, useCallback as c, useMemo as f, useEffect as B } from "react";
import "../../temp-lib/components/account/share/EmailOTPSender.js";
import "../../temp-lib/components/share/mui/Textfield.js";
import "react-hook-form";
import "../../temp-lib/components/account/share/ForgotPasswordButton.js";
import "../../temp-lib/components/account/share/PopupTitle.js";
import "../../temp-lib/components/account/share/SendEmailOTPButton.js";
import "../../temp-lib/components/footer/Footer.js";
import "../../temp-lib/components/role/EnoughRoleOnly.js";
import "../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import "../../temp-lib/components/share/apeiron/ApeironButtonDisableTip.js";
import "../../temp-lib/components/share/apeiron/ApeironChickenPopup.js";
import "../../temp-lib/components/share/apeiron/ApeironCloseButton.js";
import "../../temp-lib/components/share/apeiron/ApeironCookieConsent.js";
import "../../temp-lib/components/share/apeiron/ApeironEllipsisTypography.js";
import "../../temp-lib/components/share/apeiron/ApeironGoToButton.js";
import "../../temp-lib/components/share/apeiron/ApeironImageButton.js";
import "../../temp-lib/components/share/apeiron/ApeironInfinityDataGrid.js";
import j from "../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import "../../temp-lib/components/share/apeiron/ApeironLoopVideo.js";
import "../../temp-lib/components/share/apeiron/ApeironPagingDataGrid.js";
import "../../temp-lib/components/share/apeiron/ApeironReactPlayer.js";
import "../../temp-lib/components/share/apeiron/ApeironSectionTitle.js";
import "../../temp-lib/components/share/apeiron/ApeironTitle.js";
import "../../temp-lib/components/share/apeiron/ApeironTutorialDialog/ApeironTutorialDialog.js";
import "../../temp-lib/components/share/generic/CloseButton.js";
import "../../temp-lib/components/share/generic/IconText.js";
import "../../temp-lib/components/share/generic/ModalBox.js";
import "../../temp-lib/components/share/generic/Pagination.js";
import "../../temp-lib/components/share/generic/SearchEmptyState.js";
import "../../temp-lib/components/share/generic/Skeleton.js";
import "../../temp-lib/components/share/generic/TextInput.js";
import "next/script";
import "../../temp-lib/components/share/mui/Snackbar.js";
import "../../temp-lib/components/share/next/Image.js";
import "../../temp-lib/components/share/next/NextLink.js";
import "../../temp-lib/components/share/popup/InfoPopup.js";
import "../../temp-lib/constants/account.js";
import "../../temp-lib/constants/googleAnalytics.js";
import "../../temp-lib/constants/query.js";
import { useAccountContext as R } from "../../temp-lib/contexts/account/AccountContext.js";
import "../../temp-lib/contexts/account/Geetest4Context.js";
import "../../temp-lib/contexts/adeptus/AdeptusContext.js";
import "@apollo/client";
import "@apollo/client/link/error";
import "@apollo/client/utilities";
import "../../temp-lib/contexts/config/ConfigContext.js";
import "../../temp-lib/contexts/language/LanguageContext.js";
import "../../temp-lib/util/i18n/helper/locale.js";
import "path";
import "query-string";
import "p-retry";
import "ramda-adjunct";
import "../../temp-lib/contexts/share/LogicControlContext.js";
import { useTranslation as E } from "react-i18next";
import "../../temp-lib/contexts/fingerprint/FingerprintContext.js";
import "../../temp-lib/contexts/role/RoleContext.js";
import "../../temp-lib/contexts/share/DataGridContext.js";
import "../../temp-lib/contexts/share/MessageContext.js";
import "../../temp-lib/contexts/share/PersistQueryContext.js";
import "../../temp-lib/contexts/share/PreloadContext.js";
import "@tanstack/react-query";
import "../../temp-lib/contexts/share/ScreenLogContext.js";
import "../../config-lib/contexts/FrontendConfigContext.js";
import "../../config-lib/deserializes/yup/config.js";
import "../../config-lib/graphql/getFrontendConfig.js";
import "../../apostle-lib/deserializes/yup/apostle.js";
import "../../currency-lib/contexts/CurrencyContext.js";
import "../../temp-lib/contexts/web3/Web3Context.js";
import "../contexts/RoninNameServiceContext.js";
import "../../temp-lib/deserialize/yup/account.js";
import "../../temp-lib/deserialize/yup/chain.js";
import "../../temp-lib/deserialize/yup/locale.js";
import "../../temp-lib/deserialize/yup/page.js";
import "../../temp-lib/deserialize/yup/platform.js";
import "../../temp-lib/graphql/fragment/account.js";
import "date-fns";
import "date-fns/constants";
import "react-countdown";
import { useRouter as M } from "next/router";
import "@walletconnect/utils";
import "@wagmi/core";
import "../../temp-lib/util/query/index.js";
import "../../temp-lib/deserialize/yup/adeptusCampaign.js";
import "../../temp-lib/graphql/query/getAdeptusCampaigns.js";
import "../../temp-lib/graphql/query/getPublicAccountDetail.js";
import "../../temp-lib/graphql/mutation/processEmailRegister.js";
import "../../currency-lib/deserialize/yup/currency.js";
import "../../currency-lib/graphql/query/getCurrencyInfo.js";
import "../../currency-lib/graphql/query/getOffChainTokenBalances.js";
import "../../currency-lib/hooks/graphql/useGetTokenPriceToUSD.js";
import "../../temp-lib/util/erc20/index.js";
import "viem";
import "i18next-http-backend";
import "react-i18next/initReactI18next";
import "../../temp-lib/util/misc/formatNumberString.js";
import "../../temp-lib/util/yup/index.js";
import "../../temp-lib/wagmi/roninConnector.js";
import x from "./TokenSection.js";
import P from "./TokenSectionPopup.js";
const v = p(h)`
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
`, N = p(h)`
  align-items: center;
  display: flex;
  width: 100%;
`, W = p(x)`
  .Custom-Title {
    color: #6eeae6;
  }
  background-color: #181920;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none;
  flex: 1;
`, _ = p(x)`
  .Custom-Title {
    color: #90ffd5;
  }
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-right: none;
  flex: 1;

  .Custom-Token:last-child {
    border-right: unset;
    padding-right: unset;
  }
`, z = p(j)`
  align-self: flex-end;
  color: #3682eb;
  font-size: 14px;
  margin-right: 8px;
`, Xt = (k) => {
  const {
    className: b
  } = k, {
    pathname: T
  } = M(), [g, a] = w(!1), {
    account: t,
    fetchBalances: C
  } = R(), {
    t: n
  } = E(), m = c((r, A) => i.pipe(i.map((O) => i.find((s) => (s == null ? void 0 : s.type) === O, Object.values(A.balances || {}))), i.reject(i.isNil))(r), []), l = f(() => {
    const r = [o.Animus, o.Aprm, o.Stardust];
    return m(r, t);
  }, [t, m]), d = f(() => {
    const r = [o.Ron, o.WRon, o.Weth, o.Usdc, o.Anima, o.Aprs];
    return m(r, t);
  }, [t, m]), S = c(() => {
    a(!0);
  }, []), y = c(() => {
    a(!1);
  }, []);
  return B(() => {
    t.walletAddress && C();
  }, [t.walletAddress, T]), /* @__PURE__ */ u(v, {
    className: b,
    children: [/* @__PURE__ */ u(N, {
      children: [/* @__PURE__ */ e(_, {
        displayOne: !0,
        title: n("currency_group.onchain"),
        tokens: d
      }), /* @__PURE__ */ e(W, {
        displayOne: !0,
        title: n("currency_group.offchain"),
        tokens: l
      })]
    }), /* @__PURE__ */ e(z, {
      onClick: S,
      children: `${n("common.more")} >>`
    }), /* @__PURE__ */ e(P, {
      open: g,
      onClose: y,
      offChainTokens: l,
      onChainTokens: d
    })]
  });
};
export {
  Xt as default
};
//# sourceMappingURL=TokenSectionMobile.js.map
